// @flow
import * as React from 'react'
import SVGIcon from './SVGIcon'

type Props = {
  title?: string,
  description?: string,
  inline?: boolean,
}

export default class ErrorIcon extends React.Component<Props> {
  static defaultProps = {
    title: 'Error',
  }

  render = () => {
    return (
      <SVGIcon viewBox="0 0 74 74" {...this.props}>
        <g fill="none" fillRule="evenodd">
          <ellipse fill="#FC9688" cx="37" cy="37" rx="37" ry="37" />
          <path d="M50 49L26 25M26 49L50 25" stroke="#FFF" strokeWidth="8" strokeLinecap="round" />
        </g>
      </SVGIcon>
    )
  }
}
